<template>
  <div>

  </div>
</template>

<script>
export default {
  name: 'Logout',
  created () {
    delete localStorage.token
    this.$store.dispatch('logout')
    this.$router.push('/')
  }
}
</script>

<style scoped>
.login-wrapper {
  animation: fadein 0.6s;
}

@keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
}
</style>



// WEBPACK FOOTER //
// src/components/users/Logout.vue